import { getRequest } from "@/services/backendApi";

export interface ChangeRecord {
  id: number;
  tableName: string;
  idRow: number;
  idCase: number | null;
  fieldName: string;
  oldValue: string | null;
  newValue: string | null;
  changeType: "create" | "update" | "delete";
  /**
   * Herkunft automatisch übernommener Werte (Kundenfeedback 21.09.2026):
   * "gutachten-auto" (beim Upload in leere Felder), "gutachten-pruefung"
   * (im Prüfdialog bestätigt), "dat-auto" (DAT-Kalkulation), "schwacke"
   * (Schwacke-Abfrage). null =
   * manuelle Eingabe.
   */
  source: string | null;
  changedAt: string;
  idUser: number;
  userFirstName: string | null;
  userLastName: string | null;
  userInitials: string | null;
  orgName?: string | null;
  orgRoles?: string[] | null;
  orgIsPrivatePerson?: boolean | null;
}

/** Lesbare Bezeichnung der Herkunft eines Feldhistorie-Eintrags. */
export const CHANGE_SOURCE_LABELS: Record<string, string> = {
  "gutachten-auto": "Automatisch aus Gutachten",
  "gutachten-pruefung": "Aus Gutachten übernommen (geprüft)",
  "gutachten-manuell": "Im Gutachten-Abgleich von Hand eingetragen/korrigiert",
  "dat-auto": "Aus DAT-Kalkulation",
  schwacke: "Aus Schwacke-Abfrage",
  "beleg-auto": "Automatisch aus Rechnung/Kostenvoranschlag",
  "materialbestellung-auto": "Automatisch aus Materialbestellschein",
  "fragebogen-uebernommen": "Angabe aus dem Fragebogen übernommen",
  "fragebogen-akte-behalten": "Fragebogen-Angabe nicht übernommen (Akteninhalt behalten)",
};

/** Feldhistorie eines Fahrzeugs (tbl_cases_vehicles) nach Feldname gruppiert. */
export async function getVehicleFieldHistory(
  idCase: number,
  idVehicle: number,
): Promise<Record<string, ChangeRecord[]>> {
  const records = await getFieldHistory(idCase, "tbl_cases_vehicles", idVehicle);
  const byField: Record<string, ChangeRecord[]> = {};
  for (const record of records) {
    (byField[record.fieldName] ??= []).push(record);
  }
  return byField;
}

export async function getFieldHistory(idCase: number, tableName: string, idRow: number): Promise<ChangeRecord[]> {
  const result = await getRequest(
    `/protected/cases/${idCase}/field-history/${tableName}/${idRow}`,
    undefined,
    true,
  );
  return Array.isArray(result) ? result : [];
}
